/**
 * @generated SignedSource<<10237bc1df1c02f803b379c06a023e91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorNameAuthor$data = {
  readonly entityUuid: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "authorNameAuthor";
};
export type authorNameAuthor$key = {
  readonly " $data"?: authorNameAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorNameAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorNameAuthor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "7fa9f8cf6fec55783f6fef9e797c4bd7";

export default node;
